"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.menu.children,
      subtitle: _vm.menu.meta.title
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("h1", {
    staticClass: "page-title"
  }, [_vm._v("\n      Configurações\n    ")]), _vm._v(" "), _c("b-tabs", {
    attrs: {
      type: "is-boxed"
    }
  }, [_c("b-tab-item", {
    attrs: {
      label: "Escalas"
    }
  }, [_c("ShiftHoursTab")], 1), _vm._v(" "), _c("b-tab-item", {
    attrs: {
      label: "Escalas por funcionário"
    }
  }, [_c("ShiftAssignmentsTab")], 1)], 1)], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;